import { render, staticRenderFns } from "./VaultLockMonthView.vue?vue&type=template&id=72ba04aa&"
import script from "./VaultLockMonthView.vue?vue&type=script&lang=js&"
export * from "./VaultLockMonthView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports